export function serealizeMap<K, V>(map: Map<K, V>): [K, V][] {
  const seralizeble: [K, V][] = [];

  for (const [key, value] of map.entries()) {
    seralizeble.push([key, value]);
  }

  return seralizeble;
}
